import { render, staticRenderFns } from "./matchActivityManagement.vue?vue&type=template&id=549f1fe6&scoped=true&"
import script from "./matchActivityManagement.vue?vue&type=script&lang=js&"
export * from "./matchActivityManagement.vue?vue&type=script&lang=js&"
import style0 from "./matchActivityManagement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./matchActivityManagement.vue?vue&type=style&index=1&id=549f1fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f1fe6",
  null
  
)

component.options.__file = "matchActivityManagement.vue"
export default component.exports